import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SocketMemberService {
  private socket: Socket;

  constructor() {
    var accessToken = sessionStorage.getItem('accessToken');

    this.socket = io(`${environment.reportApiUrl}/member`, {
      extraHeaders: {
        Authorization: 'Bearer ' + accessToken,
      },
    });

    // Log connection events
    this.socket.on('connect', () => {
      console.log('Socket connected');
    });

    this.socket.on('connect_error', (error) => {
      console.log('Connection Error:', error);
    });

    this.socket.on('disconnect', () => {
      console.log('Socket disconnected');
    });
  }

  // Listen to events
  listen(eventName: string): Observable<any> {
    console.log('listen',eventName)
    if (this.socket.disconnected) {
      this.socket.connect();
    }
    return new Observable((subscriber) => {
      this.socket.on(eventName, (data) => {
        subscriber.next(data);
      });
    });
  }

  // Emit events
  emit(eventName: string, data: any) {
    console.log('emit',eventName,data)
    this.socket.emit(eventName, data);
  }

  disconnect() {
    this.socket.disconnect();
  }
  
}
